import {
  Box,
  Container,
  Grid,
  Typography,
  Step,
  StepLabel,
  Stepper,
} from "@mui/material";
import React, { useState } from "react";
import JusttawkBg from "../../../assets/justtawk-bg.png";
import JusttawkLogo from "../../../../src/assets/Justtawk-01.png";
import Logo from "../../../assets/logo.png";
import Phone from "../../../assets/phone.png";
import Phone2 from "../../../assets/phone2.png";
import Phone3 from "../../../assets/phone3.png";
import axiosInstance from "../../../services/axiosInstance";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import { useNavigate } from "react-router-dom";

const CallType = ({ nextStep }) => {
  const [callType, setCallType] = useState("");
  const userId = localStorage.getItem("userId");
  const route = useNavigate();

  const saveCallTypeData = async (type) => {
    const data = {
      userId: userId,
      callType: type,
      dropoff: "Call Type",
    };

    try {
      const res = await axiosInstance.post(apiEndPointsConfig.saveCallType, data);
      console.log("Response:", res);
      route("/faq-selection");
    } catch (error) {
      console.error("Error saving call type:", error);
    }
  };

  const handleCallTypeSelection = (type) => {
    setCallType(type);
    console.log("Selected Call Type:", type);
    saveCallTypeData(type);
  };

  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      <Grid
        item
        xs={12}
        sm={4}
        md={4}
        sx={{
          height: { xs: "50vh", md: "100vh" },
          backgroundImage: { xs: `url(${JusttawkBg})` },
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          color: "white",
          display: { xs: "flex", md: "none" },
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          p: { xs: "20px", md: "100px 0" },
          mt: { xs: "-100px", md: "0px" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              fontWeight: { xs: 400, md: 900 },
              fontSize: { xs: "1.1rem", md: "1.8rem" },
              mt: { xs: "50px", md: "0px" },
              whiteSpace: "nowrap",
            }}
          >
            Welcome to{" "}
            <Box
              sx={{
                display: { xs: "flex", md: "none" },
                justifyContent: "center",
                alignItems: "center",
                p: "7px 0",
              }}
            >
              <img
                src={JusttawkLogo}
                alt="Justtawk Logo"
                style={{
                  height: "auto",
                  maxWidth: "100%",
                  width: "220px",
                }}
              />
            </Box>
            <Box sx={{ display: { xs: "none", md: "inline" } }}>Justtawk</Box>
          </Typography>

          <Typography
            sx={{ fontWeight: { xs: 400, md: 100 }, fontSize: "1rem" }}
          >
            Your Gateway to Effortless Call Center.
          </Typography>
        </Box>
      </Grid>

      <Typography
        sx={{
          display: { xs: "flex", md: "none" },
          justifyContent: "center",
          p: "10px 0",
        }}
      >
        Step 1 - Business Details
      </Typography>

      {/* Main Content Grid */}
      <Grid container sx={{ p: { xs: "0 20px", md: "0 0" } }}>
        <Grid
          item
          md={9.5}
          xs={12}
          sx={{ height: { xs: "100%", md: "100vh" } }}
        >
          <Box sx={{ p: "5px 10px" }}>
            <Box sx={{ height: "8vh", display: { xs: "none", md: "flex" } }}>
              <img src={Logo} alt="Logo" height="100%" width="200" />
            </Box>
          </Box>

          <Container maxWidth="md">
            <Box
              sx={{ padding: { xs: "0px 0px 0 0px", md: "50px 0px 0 0px" } }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "1.6rem", md: "2.5rem" },
                  lineHeight: { xs: "32px", md: "60px" },
                  fontWeight: 900,
                }}
              >
                Define Your Core Operations
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "0.95rem", md: "1.4rem" },
                  fontWeight: 100,
                  lineHeight: { xs: "18px", md: "25px" },
                  color: { xs: "black", md: "#6D6D6D" },
                  mt: "15px",
                }}
              >
                Tell us how your customers typically reach out. This helps us
                optimize your call handling settings.
              </Typography>
            </Box>

            {/* Hardcoded CallType Buttons without .map */}
            <Grid
              container
              spacing={2}
              sx={{
                mt: {
                  xs: 1,
                  md: 10,
                },
                p: {
                  xs: 0,
                  md: "0 100px 0 0",
                },
              }}
            >
              <Grid item xs={12} md={4} key="inbound" sx={{ p: 1 }}>
                <Box
                  onClick={() => handleCallTypeSelection("inbound")}
                  sx={{
                    p: { xs: 0.5, md: 2.1 },
                    pl: { xs: 2, md: 0 },
                    border: "1px solid",
                    borderColor:
                      callType === "inbound" ? "#2C75D3" : "#b6b6b6ff",
                    borderRadius: "8px",
                    cursor: "pointer",
                    textAlign: "center",
                    backgroundColor:
                      callType === "inbound" ? "#E6F0FF" : "white",
                    transition: "all 0.2s ease-in-out",
                    display: "flex",
                    flexDirection: { xs: "row", md: "column" },
                    gap: { xs: 1, md: 0 },
                    alignItems: "center",
                    height: "100%",
                    justifyContent: { xs: "flex-start", md: "center" },
                    boxShadow:
                      callType === "inbound"
                        ? "0 4px 8px rgba(0, 0, 0, 0.1)"
                        : "0 2px 4px rgba(0, 0, 0, 0.4)",
                    "&:hover": {
                      borderColor: "grey",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                    },
                  }}
                >
                  <Box sx={{ marginBottom: "8px" }}>
                    <img
                      src={Phone2}
                      alt="Inbound Icon"
                      style={{ width: "2rem", height: "2rem" }}
                    />
                  </Box>
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      color: callType === "inbound" ? "#2C75D3" : "grey",
                    }}
                  >
                    Inbound
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={4} key="outbound" sx={{ p: 1 }}>
                <Box
                  onClick={() => handleCallTypeSelection("outbound")}
                  sx={{
                    p: { xs: 0.5, md: 2.1 },
                    pl: { xs: 2, md: 0 },
                    border: "1px solid",
                    borderColor:
                      callType === "outbound" ? "#2C75D3" : "#b6b6b6ff",
                    borderRadius: "8px",
                    cursor: "pointer",
                    textAlign: "center",
                    backgroundColor:
                      callType === "outbound" ? "#E6F0FF" : "white",
                    transition: "all 0.2s ease-in-out",
                    display: "flex",
                    flexDirection: { xs: "row", md: "column" },
                    gap: { xs: 1, md: 0 },
                    alignItems: "center",
                    height: "100%",
                    justifyContent: { xs: "flex-start", md: "center" },
                    boxShadow:
                      callType === "outbound"
                        ? "0 4px 8px rgba(0, 0, 0, 0.1)"
                        : "0 2px 4px rgba(0, 0, 0, 0.4)",
                    "&:hover": {
                      borderColor: "grey",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                    },
                  }}
                >
                  <Box sx={{ marginBottom: "8px" }}>
                    <img
                      src={Phone}
                      alt="Outbound Icon"
                      style={{ width: "2rem", height: "2rem" }}
                    />
                  </Box>
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      color: callType === "outbound" ? "#2C75D3" : "grey",
                    }}
                  >
                    Outbound
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={4} key="both" sx={{ p: 1 }}>
                <Box
                  onClick={() => handleCallTypeSelection("both")}
                  sx={{
                    p: { xs: 0.5, md: 2.1 },
                    pl: { xs: 2, md: 0 },
                    border: "1px solid",
                    borderColor: callType === "both" ? "#2C75D3" : "#b6b6b6ff",
                    borderRadius: "8px",
                    cursor: "pointer",
                    textAlign: "center",
                    backgroundColor: callType === "both" ? "#E6F0FF" : "white",
                    transition: "all 0.2s ease-in-out",
                    display: "flex",
                    flexDirection: { xs: "row", md: "column" },
                    gap: { xs: 1, md: 0 },
                    alignItems: "center",
                    height: "100%",
                    justifyContent: { xs: "flex-start", md: "center" },
                    boxShadow:
                      callType === "both"
                        ? "0 4px 8px rgba(0, 0, 0, 0.1)"
                        : "0 2px 4px rgba(0, 0, 0, 0.4)",
                    "&:hover": {
                      borderColor: "grey",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                    },
                  }}
                >
                  <Box sx={{ marginBottom: "8px" }}>
                    <img
                      src={Phone3}
                      alt="Both Icon"
                      style={{ width: "2rem", height: "2rem" }}
                    />
                  </Box>
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      color: callType === "both" ? "#2C75D3" : "grey",
                    }}
                  >
                    Both
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Grid>

        {/* Right Sidebar (Stepper) */}
        <Grid
          item
          xs={12}
          md={2.5}
          sx={{
            background: "#1A5CB0",
            padding: "0 0px 50px 0",
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
          }}
        >
          <Typography
            sx={{
              fontSize: "1.2rem",
              color: "white",
              fontWeight: 900,
              p: "100px 20px 40px 20px",
            }}
          >
            Quick & Easy Setup
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Stepper
              activeStep={0}
              orientation="vertical"
              sx={{
                color: "white",
                "& .MuiStepLabel-label": { color: "white" },
              }}
            >
              <Step>
                <StepLabel>
                  <Typography
                    sx={{ color: "white", fontSize: "0.8rem", ml: 1, mb: 0 }}
                  >
                    Business Details
                  </Typography>
                </StepLabel>
              </Step>
              <Step>
                <StepLabel>
                  <Typography
                    sx={{ color: "#6198DE", fontSize: "0.8rem", ml: 1, mb: 0 }}
                  >
                    Define Frequently Ask Questions
                  </Typography>
                </StepLabel>
              </Step>
              <Step>
                <StepLabel>
                  <Typography
                    sx={{ color: "#6198DE", fontSize: "0.8rem", ml: 1, mb: 0 }}
                  >
                    Select Customer Care Number
                  </Typography>
                </StepLabel>
              </Step>
            </Stepper>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CallType;
